require('./dist/signal/ds6/signal.css');
